<template>
  <div class="home ">
    <!--Stats cards-->
    <div class="row" v-if="dashboard">
      <div class="col-md-6">
        <div class="col-md-6" v-for="index in dashboard.data.amount">
          <stats-card>
            <div
              class="numbers"
              slot="content"
              v-on:click="clickCard(index.description)"
            >
              <div class="title" text-center>{{ index.description }}</div>
              <div class="value">
                <div
                  v-bind:style="{ backgroundColor: index.color }"
                  style="padding: 10px 0; border-radius: 100px;color: white"
                >
                  {{ formatAmount(index) }}
                </div>
              </div>
            </div>
          </stats-card>
        </div>
      </div>

      <div class="col-md-6" v-if="dashboard.data.list">
        <div class="card">
          <component-table
            eventName="selectItem"
            :title="table.title"
            :sub-title="table.subTitle"
            :data="list || dashboard.data.list"
            :columns="table.columns"
            :headers="table.headers"
            :buttons="table.buttons"
          />
        </div>
      </div>
    </div>
    <div class="row" v-if="dashboard">
      <div class="col-md-6" v-if="dashboard.data.industry">
        <div class="card">
          <component-table
            eventName="selectIndustry"
            :title="tableIndustry.title"
            :sub-title="tableIndustry.subTitle"
            :data="list || dashboard.data.industry"
            :columns="tableIndustry.columns"
            :headers="tableIndustry.headers"
            :buttons="tableIndustry.buttons"
          />
        </div>
      </div>

      <!-- PIZZA -->
      <div class="col-md-3">
        <chart-card
          v-if="this.AllCity"
          :chart-data="this.AllCity"
          chart-type="Pie"
        >
          <h4 class="title" slot="title">Cidades</h4>
          <span slot="subTitle">Vendas x Cidades</span>
          <div slot="legend" v-if="FlagUsers == true">
            <i
              class="fa fa-circle "
              v-bind:style="{ color: preferencesChart.colors[0] }"
            ></i>
            {{ this.AllCity.labels[0] }} - {{ this.AllCity.series[0] }}
            <i
              class="fa fa-circle"
              v-bind:style="{ color: preferencesChart.colors[1] }"
            ></i>
            {{ this.AllCity.labels[1] }} - {{ this.AllCity.series[1] }}
            <br />
            <i
              class="fa fa-circle "
              v-bind:style="{ color: preferencesChart.colors[2] }"
            ></i>
            {{ this.AllCity.labels[2] }} - {{ this.AllCity.series[2] }}
            <i
              class="fa fa-circle"
              v-bind:style="{ color: preferencesChart.colors[3] }"
            ></i>
            {{ this.AllCity.labels[3] }} - {{ this.AllCity.series[3] }}
            <br />
            <i
              class="fa fa-circle "
              v-bind:style="{ color: preferencesChart.colors[4] }"
            ></i>
            {{ this.AllCity.labels[4] }} - {{ this.AllCity.series[4] }}
            <i
              class="fa fa-circle"
              v-bind:style="{ color: preferencesChart.colors[5] }"
            ></i>
            {{ this.AllCity.labels[5] }} - {{ this.AllCity.series[5] }}
            <br />
            <i
              class="fa fa-circle"
              v-bind:style="{ color: preferencesChart.colors[6] }"
            ></i>
            {{ this.AllCity.labels[6] }} - {{ this.AllCity.series[6] }}
          </div>
        </chart-card>
      </div>

      <!-- PIZZA -->
      <div class="col-md-3">
        <chart-card
          v-if="this.AllUsers"
          :chart-data="this.AllUsers"
          chart-type="Pie"
        >
          <h4 class="title" slot="title">Usuários</h4>
          <span slot="subTitle"> Estáveis x Instáveis </span>
          <div slot="legend" v-if="FlagUsers == true">
            <i
              class="fa fa-circle "
              v-bind:style="{ color: preferencesChart.colors[1] }"
            ></i>
            {{ this.AllUsers.labels[1] }} - {{ this.AllUsers.series[1] }}
            <br />
            <i
              class="fa fa-circle"
              v-bind:style="{ color: preferencesChart.colors[0] }"
            ></i>
            {{ this.AllUsers.labels[0] }} - {{ this.AllUsers.series[0] }}
            <br />
          </div>
        </chart-card>
      </div>

    </div>
    <div class="col-md-12 col-xs-8">
      <chart-card
        v-if="this.Solds.series[0]"
        :chart-options="preferencesChart.options"
        :chart-data="this.Solds"
        chart-type="Line"
      >
        <h4 class="title" slot="title">Vendas X Anúncios</h4>
        <span slot="subTitle">Relatório Diário</span>
        <div slot="legend">
          <div v-if="this.Solds.series[0].length > 0">
            <i
              class="fa fa-circle "
              v-bind:style="{ color: preferencesChart.colorsLine[0] }"
            ></i
            >Adicionado
          </div>
          <div v-if="this.Solds.series[1].length > 0">
            <i
              class="fa fa-circle "
              v-bind:style="{ color: preferencesChart.colorsLine[2] }"
            ></i>
            Reservado
          </div>
          <div v-if="this.Solds.series[2].length > 0">
            <i
              class="fa fa-circle "
              v-bind:style="{ color: preferencesChart.colorsLine[3] }"
            ></i>
            Ofertado
          </div>
        </div>
      </chart-card>
    </div>

    
  </div>
</template>

<script>
import StatsCard from "components/UIComponents/Cards/StatsCard.vue";
import ChartCard from "components/UIComponents/Cards/ChartCard.vue";
import ComponentTable from "components/UIComponents/Lists/ComponentTable.vue";

import { mapActions, mapState, mapGetters } from "vuex";
const headers = ["Marca", "Modelo", "Tipo", "Quantidade"];
const tableColumns = ["brand", "model", "type", "amount"];

const headersIndustry = [
  "Lojistas",
  "Reservado",
  "Ofertado",
  "Total",
];
const tableColumnsIndustry = [
  "name",
  "reserved",
  "auction",
  "formattedValueCentavos",
];

export default {
  components: {
    StatsCard,
    ChartCard,
    ComponentTable,
  },
  created() {
    this.initData();
  },
  props: {
    selected: {
      type: Object,
      default: () => {
        return null;
      },
    },
    list: {
      type: Array,
      default: () => {
        return null;
      },
    },
  },
  computed: {
    ...mapState({
      dashboard: ({ dashboard }) => dashboard.selected,
    }),
    ...mapGetters({
      sidebarFlag: "sidebarFlag",
    }),
  },

  methods: {
    ...mapActions(["getDashboardList"]),

    goTo(page) {
      this.$router.push("/admin/" + page);
    },

    clickCard(page) {
      if (page == "Lojistas à Auditar") {
        this.$router.push("/admin/lojistas/lista");
      } else if (page == "Suporte Pendente") {
        this.$router.push("/admin/suportes/lista");
      } else if (page == "Ofertas") {
        this.$router.push("/admin/ofertas/lista");
      } else if (page == "Anúncios Ativos") {
        this.$router.push("/admin/anuncios/lista");
      } else if (page == "Usuários Cadastrados") {
        this.$router.push("/admin/usuarios/lista");
      } else if (page == "Administradores") {
        this.$router.push({
          name: "Usuários - Lista",
          params: { isAdmin: true },
        });
      }
    },

    formatAmount(index) {
      if (index.description == "Líquido" || index.description == "Wirecard") {
        return parseInt(("" + index.amount).onlyNumber()).int2Money();
      } else {
        return index.amount;
      }
    },

    mountSellingCityPieChart(dash) {
      for (var i = 0; i < dash.length; i++) {
        var x = dash[i].city;
        this.AllCity.labels[i] = String(x);
        this.AllCity.series[i] = parseInt(dash[i].amount);
      }

      this.FlagUsers = true;
    },

    mountPieChart(dash) {
      for (var i = 0; i < dash.length; i++) {
        var x = dash[i].description;

        this.AllUsers.labels[i] = String(x).replace("Usuários", "");
        this.AllUsers.series[i] = parseInt(dash[i].amount);
      }
      this.FlagUsers = true;
    },
    mountLineChart(dash) {
      this.Solds.labels = [];
      this.Solds.series[0] = [];
      this.Solds.series[1] = [];
      this.Solds.series[2] = [];

      let auxLabels = [];
      for (var i = 0; i < dash.additional.length; i++) {
        if (!auxLabels.includes(dash.additional[i].day)) {
          auxLabels.push(dash.additional[i].day);
        }
      }

      for (var i = 0; i < dash.reserved.length; i++) {
        if (!auxLabels.includes(dash.reserved[i].day)) {
          auxLabels.push(dash.reserved[i].day);
        }
      }
      for (var i = 0; i < dash.auction.length; i++) {
        if (!auxLabels.includes(dash.auction[i].day)) {
          auxLabels.push(dash.auction[i].day);
        }
      }

      auxLabels.sort(function(a, b) {
        return a - b;
      });

      this.Solds.labels = auxLabels;

      for (var i = 0; i < this.Solds.labels.length; i++) {
        var additional = 0; //Novos
        for (var j = 0; j < dash.additional.length; j++) {
          if (dash.additional[j].day == this.Solds.labels[i]) {
            additional = parseInt(dash.additional[j].amount);
          }
        }
        this.Solds.series[0].push(additional);

        var reserved = 0; //Vendidos
        for (var j = 0; j < dash.reserved.length; j++) {
          if (dash.reserved[j].day == this.Solds.labels[i]) {
            reserved = parseInt(dash.reserved[j].amount);
          }
        }
        this.Solds.series[1].push(reserved);

        var auction = 0; //Vendidos
        for (var j = 0; j < dash.auction.length; j++) {
          if (dash.auction[j].day == this.Solds.labels[i]) {
            auction = parseInt(dash.auction[j].amount);
          }
        }
        this.Solds.series[2].push(auction);
      }
    },

    initData() {
      this.getDashboardList().then((res) => {
          this.mountPieChart(res.user);
          this.mountLineChart(res.daily);
          this.mountSellingCityPieChart(res.city);
        })
        .catch({});
    },
  },

  data() {
    return {
      table: {
        title: "Veículos",
        subTitle: "Mais Vendidos",
        headers: [...headers],
        columns: [...tableColumns],
      },
      tableIndustry: {
        title: "Lojistas",
        subTitle: "Maiores Consumidores",
        headers: [...headersIndustry],
        columns: [...tableColumnsIndustry],
      },
      AllCity: {
        labels: [],
        series: [],
      },
      AllUsers: {
        labels: [],
        series: [],
      },
      FlagUsers: null,
      Solds: {
        labels: [],
        series: [],
      },
      QntUser: null,
      QntCostumer: null,
      preferencesChart: {
        data: {
          labels: ["62%", "32%", "6%"],
          series: [62, 32, 6],
        },
        options: {},
        colors: [
          "#aa0002",
          "#3aaeae",
          "#0063BA",
          "#dab901",
          "#008080",
          "#ff7373",
        ],
        colorsLine: [
          "#aa0002",
          "#3aaeae",
          "#dab901",
          "#0063BA",
          "#008080",
          "#ff7373",
        ],
      },
    };
  },
};
</script>
<style lang="scss">
.home {
  box-sizing: border-box;
}
.numbers {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Home.vue